import React, { useEffect } from 'react';

import { Box, Stack, TextField, Button, List, ListItem, IconButton, ListItemText, Paper, Container, Grid, Typography, Divider, InputAdornment, Tooltip, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Code, FormatClear, Save, Search } from '@mui/icons-material';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';

import Service from '../../../../util/Service';
import { IB } from '../../../page/portal/setting/SettingPanel';

const RootServiceTask = React.forwardRef((props, ref) => {
    // export default function RootServiceTask2(props) {
    const { item, processo } = props;
    const childRef = React.useRef();
    const [activeStep, setActiveStep] = React.useState(0);
    const [tipo, setTipo] = React.useState('');
    const [task, setTask] = React.useState();
    const [lista, setLista] = React.useState([]);
    const [url, setUrl] = React.useState('');
    const [method, setMethod] = React.useState('GET');
    const [dado, setDado] = React.useState('');
    const [header, setHeader] = React.useState('');
    const [headers, setHeaders] = React.useState([]);
    const [code, setCode] = React.useState('');
    const [isCode, setIsCode] = React.useState(false);
    

    React.useImperativeHandle(ref, () => ({
        childMethod() {
            salva();
        }
    }))
    useEffect(() => {
        console.log(item.id);
        if (item && processo) {
            const t = processo.lstTask.find((i) => i.idTask === item.id);
            if (t) {
                console.log(t);
                setTipo(t.tipo);
                if( t.code && t.code.length > 0){
                    setCode( t.code);
                    setIsCode( true);
                }
                setMethod(t.method)
                // setActiveStep(1);
                setTask(t);
            }
        }
        buscaChaves();

    }, [])
    React.useEffect(() => {
        if (task) {
            setUrl(task.url);
            setDado(task.dado);
            if (task.header) setHeaders(task.header);
        }
    }, [task])

    const buscaChaves = () => {
        Service.GET("/api/security/setting/buscaByTipo/securityKey").then(r => {
            setLista(r);
        })
    }

    const handleComplete = () => {
        const send = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            tipo: tipo,
            nome: item.businessObject.name,
            url: url,
            method: method,
            dado: dado,
            header: headers,
            code: code
        }
        Service.POST("/api/bpmn/salvarTaskDoProcesso", send).then(resp => {
            console.log(resp);
        }).catch(error => {
            console.error(error)
        })
    };
    const remove = (item) => {
        let arr = [];
        for (let x in headers) {
            if (headers[x] !== item) {
                arr.push(headers[x])
            }
        }
        setHeaders(arr);
    }
    function handleSalvaCodigo(){
        handleComplete();
    }
    function handleHabilitaCode(){
        setIsCode( !isCode);
        if( !code || code.length ===0){
            setCode(
`from("direct:start")
    .process(process)
;
function process(e) {
   e.getIn().setBody({
      parm1: 'abcd1234',
   });
}`);
    
        }
    
    }

    function salva() {
        // console.log('>>>salva from parent<<<');
        // if (childRef && childRef.current) childRef.current.childMethod();
        handleComplete();
    }
    function handleClick() {
        alert('ainda não implentando!')
    }
    function handleChangeMethod(e){
       const val = e.target.value;
       if( val === 'POST'){
        setIsCode(true);
        if( code.length === 0 ){
            setCode(
`from("direct:start")
    .process(process)
;
function process(e) {
    e.getIn().setBody({
        parm1: 'abcd1234',
    });
}`);
        }
       }
       setMethod(val)
    }

    return (
        <Container maxWidth="lg" sx={{ mt: '20px' }}>
            <Stack direction="row" spacing={0} id='editor_tool'>
                <Tooltip title={!isCode?"Ativa codigo":"Destativa codigo"}>
                    <IB
                        color={isCode ?"primary":""} 
                        onClick={handleHabilitaCode}
                        size="small"
                    >
                        <Code />
                    </IB>
                </Tooltip>

                {isCode &&
                <React.Fragment>
                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />    
                    <Tooltip title="Salva codigo">
                    <IB
                        color="primary" 
                        onClick={handleSalvaCodigo}
                        size="small"
                    >
                        <Save />
                    </IB>
                </Tooltip>
                </React.Fragment>}
            </Stack>
            {isCode && 
            <Editor
                value={code}
                onValueChange={t => setCode(t)}
                highlight={code => {
                    // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                    return highlight(code, languages.js)
                }}
                padding={10}
                style={{
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 12,
                    minHeight: '400px'
                }}
            />}
            <Typography variant='body2'>
                &bull;Para utilizar as chaves de segurança coloque entre {"{ }"}, exemplo: "Authorization: Api-Token {"{"}security-key-abc{"}"}"
            </Typography>
            {isCode && (method === 'GET') &&            
            <Typography variant='body2'>
                &bull;Para utilizar parametros de codigo use as variavies dentro de {"{ }"}, exemplo: "http://localhost:8080?data={"{"}parm1{"}"}.<br/>
                Cuidado pois se tiver o mesmo nome da chave a precedencia é a chave.
            </Typography>
            }
            {isCode && (method === 'POST') &&
            <Typography variant='body2'>
                &bull;Codigo informando dentro do <strong>e.getIn().setBody()</strong> será o body do POST com Content-Type: application/json.
            </Typography>
            }
            <Paper sx={{ mt: '20px', p: 2 }}>
                <Grid container spacing={2} >
                    <Grid size={8}>
                        <Stack spacing={1}>
                            <Stack direction="row" spacing={1}>
                                <TextField label="API" size='small' fullWidth
                                    value={url} onChange={(e) => setUrl(e.target.value)}
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle visibility"
                                                        edge="end"
                                                        onClick={handleClick}
                                                    >
                                                        <Search />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        },
                                    }}
                                />
                                {/* <TextField id="url" label="Url" variant="standard"
                                    sx={{ width: '80%' }}
                                    value={url} onChange={(e) => setUrl(e.target.value)}
                                /> */}
                                {/* <TextField id="metodo" size='small' label="Method" variant="outlined" value={method} onChange={(e) => setMethod(e.target.value)} /> */}
                                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                    <InputLabel id="metodo-label">Method</InputLabel>
                                    <Select
                                        labelId="metodo-label"
                                        id="metodo"
                                        value={method}
                                        label="Method"
                                        onChange={handleChangeMethod}
                                    >                                        
                                        <MenuItem value={'GET'}>GET</MenuItem>
                                        <MenuItem value={'POST'}>POST</MenuItem>                                        
                                    </Select>
                                </FormControl>
                            </Stack>
                            <div>
                                <TextField id="header" label="Header" variant="outlined"
                                    sx={{ width: '80%' }} size='small'
                                    value={header} onChange={(e) => setHeader(e.target.value)}
                                />
                                <IconButton type="button" color="primary"
                                    sx={{ p: '10px' }} aria-label="add"
                                    onClick={() => {

                                        if (header && header.length > 0) {
                                            let arr = [...headers];
                                            arr.push(header);
                                            setHeaders(arr);
                                            setHeader('');
                                        }
                                    }}>
                                    <AddIcon />
                                </IconButton>
                            </div>
                            {/* <TextField id="dados" label="Dados" variant="standard"
                                value={dado} onChange={(e) => setDado(e.target.value)}
                            /> */}
                        </Stack>
                        {(headers && headers.length > 0) &&
                            <Paper sx={{ mt: 2 }}>
                                <List>
                                    {headers && headers.map((l, i) => (
                                        <ListItem key={i}
                                            secondaryAction={
                                                <IconButton edge="end" aria-label="delete" onClick={() => remove(l)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemText
                                                secondary={l.length > 100 ? l.substr(0, 100) + "..." : l}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>}
                    </Grid>
                    <Grid size={4}>
                        <Box sx={{ border: '1px solid black', height: '100%' }}>
                            <Stack spacing={2} sx={{ p: 2 }}>
                                <Typography align='center'>Chaves de seguranças disponíveis</Typography>
                                <List sx={{ width: '100%', maxWidth: 360 }}>
                                    {lista && lista.map((row, id) => (
                                        <React.Fragment key={row.id}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemText
                                                    primary={row.confs.key}
                                                    secondary={
                                                        <React.Fragment>
                                                            <Typography
                                                                component="span" variant="body2"
                                                                sx={{ color: 'text.primary', display: 'inline' }}
                                                            >
                                                                {row.user.nome}
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontSize: "0.6rem",
                                                                    color: 'text.primary',
                                                                    display: 'inline'
                                                                }}>
                                                                {" — " + row.confs.descricao}
                                                            </Typography>
                                                        </React.Fragment>
                                                    }
                                                />
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
})
export default RootServiceTask;